var map = {
	"./appLogo.png": 5683,
	"./bg.jpg": 16,
	"./browser__chrome.png": 1886,
	"./browser__edge.png": 3532,
	"./browser__firefox.png": 6666,
	"./completeProfile__listIcon.png": 3806,
	"./completeProfile__teaser.png": 5822,
	"./download__android.png": 1395,
	"./download__ios--comingSoon.png": 3148,
	"./download__ios.png": 698,
	"./dummy.png": 1272,
	"./ec__busy.png": 99,
	"./ec__stickerSelectedMarker.png": 7323,
	"./ec__stickerUnselect.png": 4285,
	"./enterCode__icon.png": 8202,
	"./enterCode__loggedInMarker.png": 3298,
	"./enterCode__newStickerMarker.png": 5770,
	"./enterCode__openPacksInfoArrow.png": 8279,
	"./enterCode__packsOpenInfoBg.png": 9381,
	"./enterCode__popupCloseIcon.png": 451,
	"./enterCode__rewardCoins.png": 1605,
	"./enterCode__rewardDeco.png": 3347,
	"./footer__paniniLogo.png": 8832,
	"./header__iconBack.png": 84,
	"./icon__coins.png": 9729,
	"./sandbox__cover.jpg": 384,
	"./sandbox__pack.jpg": 789,
	"./sandbox__shopAlbum.png": 9554,
	"./sandbox__shopCoins1.png": 1399,
	"./sandbox__shopCoins2.png": 7900,
	"./sandbox__shopCoins3.png": 6924,
	"./sandbox__shopStickers.png": 7266,
	"./sandbox__shopYearbook.png": 4294,
	"./sandbox__sticker.jpg": 2835,
	"./teaser--asobal23-24--de.jpg": 8441,
	"./teaser--asobal23-24--en.jpg": 1499,
	"./teaser--asobal23-24--es.jpg": 5711,
	"./teaser--asobal23-24--fr.jpg": 4714,
	"./teaser--asobal23-24--it.jpg": 7513,
	"./teaser--asobal23-24--nl.jpg": 3603,
	"./teaser--asobal23-24--pt-br.jpg": 9510,
	"./teaser--brasileirao2024--de.jpg": 1879,
	"./teaser--brasileirao2024--en.jpg": 6121,
	"./teaser--brasileirao2024--es.jpg": 7553,
	"./teaser--brasileirao2024--fr.jpg": 2906,
	"./teaser--brasileirao2024--it.jpg": 9437,
	"./teaser--brasileirao2024--nl.jpg": 3807,
	"./teaser--brasileirao2024--pt-br.jpg": 3951,
	"./teaser--brasileirao2025--de.jpg": 8626,
	"./teaser--brasileirao2025--en.jpg": 913,
	"./teaser--brasileirao2025--es.jpg": 277,
	"./teaser--brasileirao2025--fr.jpg": 4445,
	"./teaser--brasileirao2025--it.jpg": 8668,
	"./teaser--brasileirao2025--nl.jpg": 3589,
	"./teaser--brasileirao2025--pt-br.jpg": 7999,
	"./teaser--calciatori-femminile23-24--de.jpg": 889,
	"./teaser--calciatori-femminile23-24--en.jpg": 5901,
	"./teaser--calciatori-femminile23-24--es.jpg": 9709,
	"./teaser--calciatori-femminile23-24--fr.jpg": 7898,
	"./teaser--calciatori-femminile23-24--it.jpg": 2852,
	"./teaser--calciatori-femminile23-24--nl.jpg": 5373,
	"./teaser--calciatori-femminile23-24--pt-br.jpg": 5956,
	"./teaser--calciatori23-24--de.jpg": 6965,
	"./teaser--calciatori23-24--en.jpg": 6565,
	"./teaser--calciatori23-24--es.jpg": 1134,
	"./teaser--calciatori23-24--fr.jpg": 4733,
	"./teaser--calciatori23-24--it.jpg": 4527,
	"./teaser--calciatori23-24--nl.jpg": 6133,
	"./teaser--calciatori23-24--pt-br.jpg": 7721,
	"./teaser--de.jpg": 4591,
	"./teaser--en.jpg": 6265,
	"./teaser--es.jpg": 2811,
	"./teaser--fcbq23-24--de.jpg": 8744,
	"./teaser--fcbq23-24--en.jpg": 3708,
	"./teaser--fcbq23-24--es.jpg": 6056,
	"./teaser--fcbq23-24--fr.jpg": 8471,
	"./teaser--fcbq23-24--it.jpg": 9049,
	"./teaser--fcbq23-24--nl.jpg": 3466,
	"./teaser--fcbq23-24--pt-br.jpg": 2014,
	"./teaser--fcbq24-25--de.jpg": 7118,
	"./teaser--fcbq24-25--en.jpg": 1166,
	"./teaser--fcbq24-25--es.jpg": 5552,
	"./teaser--fcbq24-25--fr.jpg": 1401,
	"./teaser--fcbq24-25--it.jpg": 2842,
	"./teaser--fcbq24-25--nl.jpg": 3364,
	"./teaser--fcbq24-25--pt-br.jpg": 5826,
	"./teaser--fifa365--de.jpg": 370,
	"./teaser--fifa365--en.jpg": 2744,
	"./teaser--fifa365--es.jpg": 2461,
	"./teaser--fifa365--fr.jpg": 1609,
	"./teaser--fifa365--it.jpg": 6118,
	"./teaser--fifa365--nl.jpg": 4028,
	"./teaser--fifa365--pt-br.jpg": 6482,
	"./teaser--fifa365_2025--de.jpg": 5710,
	"./teaser--fifa365_2025--en.jpg": 3957,
	"./teaser--fifa365_2025--es.jpg": 4140,
	"./teaser--fifa365_2025--fr.jpg": 2237,
	"./teaser--fifa365_2025--it.jpg": 1777,
	"./teaser--fifa365_2025--nl.jpg": 9335,
	"./teaser--fifa365_2025--pt-br.jpg": 847,
	"./teaser--fifae2025--de.jpg": 7595,
	"./teaser--fifae2025--en.jpg": 4757,
	"./teaser--fifae2025--es.jpg": 9021,
	"./teaser--fifae2025--fr.jpg": 3636,
	"./teaser--fifae2025--it.jpg": 9396,
	"./teaser--fifae2025--nl.jpg": 2025,
	"./teaser--fifae2025--pt-br.jpg": 8243,
	"./teaser--foot2023--de.jpg": 5174,
	"./teaser--foot2023--en.jpg": 5843,
	"./teaser--foot2023--es.jpg": 6701,
	"./teaser--foot2023--fr.jpg": 3985,
	"./teaser--foot2023--it.jpg": 9907,
	"./teaser--foot2023--nl.jpg": 957,
	"./teaser--foot2023--pt-br.jpg": 20,
	"./teaser--foot2024--de.jpg": 3657,
	"./teaser--foot2024--en.jpg": 9535,
	"./teaser--foot2024--es.jpg": 5488,
	"./teaser--foot2024--fr.jpg": 915,
	"./teaser--foot2024--it.jpg": 9301,
	"./teaser--foot2024--nl.jpg": 961,
	"./teaser--foot2024--pt-br.jpg": 5156,
	"./teaser--fr.jpg": 4595,
	"./teaser--it.jpg": 8779,
	"./teaser--laliga--de.jpg": 7942,
	"./teaser--laliga--en.jpg": 4955,
	"./teaser--laliga--es.jpg": 2555,
	"./teaser--laliga--fr.jpg": 4205,
	"./teaser--laliga--it.jpg": 9824,
	"./teaser--laliga--nl.jpg": 9231,
	"./teaser--laliga--pt-br.jpg": 2265,
	"./teaser--laliga2024-25--de.jpg": 2663,
	"./teaser--laliga2024-25--en.jpg": 3703,
	"./teaser--laliga2024-25--es.jpg": 3102,
	"./teaser--laliga2024-25--fr.jpg": 3292,
	"./teaser--laliga2024-25--it.jpg": 307,
	"./teaser--laliga2024-25--nl.jpg": 8970,
	"./teaser--laliga2024-25--pt-br.jpg": 8451,
	"./teaser--laliga2025-26--de.jpg": 45,
	"./teaser--laliga2025-26--en.jpg": 7457,
	"./teaser--laliga2025-26--es.jpg": 2861,
	"./teaser--laliga2025-26--fr.jpg": 4382,
	"./teaser--laliga2025-26--it.jpg": 1722,
	"./teaser--laliga2025-26--nl.jpg": 3815,
	"./teaser--laliga2025-26--pt-br.jpg": 8830,
	"./teaser--laliga2026-27--de.jpg": 7300,
	"./teaser--laliga2026-27--en.jpg": 8807,
	"./teaser--laliga2026-27--es.jpg": 8431,
	"./teaser--laliga2026-27--fr.jpg": 2364,
	"./teaser--laliga2026-27--it.jpg": 10,
	"./teaser--laliga2026-27--nl.jpg": 2177,
	"./teaser--laliga2026-27--pt-br.jpg": 5142,
	"./teaser--nl.jpg": 1226,
	"./teaser--ssl2023--de.jpg": 6907,
	"./teaser--ssl2023--en.jpg": 6961,
	"./teaser--ssl2023--es.jpg": 6441,
	"./teaser--ssl2023--fr.jpg": 9705,
	"./teaser--ssl2023--it.jpg": 7559,
	"./teaser--ssl2023--nl.jpg": 7785,
	"./teaser--ssl2023--pt-br.jpg": 8014,
	"./teaser--teamchile2023--de.jpg": 2185,
	"./teaser--teamchile2023--en.jpg": 3093,
	"./teaser--teamchile2023--es.jpg": 9523,
	"./teaser--teamchile2023--fr.jpg": 4630,
	"./teaser--teamchile2023--it.jpg": 764,
	"./teaser--teamchile2023--nl.jpg": 1760,
	"./teaser--teamchile2023--pt-br.jpg": 9591,
	"./teaser--voleibol2024--de.jpg": 3227,
	"./teaser--voleibol2024--en.jpg": 3086,
	"./teaser--voleibol2024--es.jpg": 4898,
	"./teaser--voleibol2024--fr.jpg": 5572,
	"./teaser--voleibol2024--it.jpg": 8274,
	"./teaser--voleibol2024--nl.jpg": 9634,
	"./teaser--voleibol2024--pt-br.jpg": 644,
	"./teaser.jpg": 6588,
	"./wordmark--long.png": 7939,
	"images/appLogo.png": 5683,
	"images/bg.jpg": 16,
	"images/browser__chrome.png": 1886,
	"images/browser__edge.png": 3532,
	"images/browser__firefox.png": 6666,
	"images/completeProfile__listIcon.png": 3806,
	"images/completeProfile__teaser.png": 5822,
	"images/download__android.png": 1395,
	"images/download__ios--comingSoon.png": 3148,
	"images/download__ios.png": 698,
	"images/dummy.png": 1272,
	"images/ec__busy.png": 99,
	"images/ec__stickerSelectedMarker.png": 7323,
	"images/ec__stickerUnselect.png": 4285,
	"images/enterCode__icon.png": 8202,
	"images/enterCode__loggedInMarker.png": 3298,
	"images/enterCode__newStickerMarker.png": 5770,
	"images/enterCode__openPacksInfoArrow.png": 8279,
	"images/enterCode__packsOpenInfoBg.png": 9381,
	"images/enterCode__popupCloseIcon.png": 451,
	"images/enterCode__rewardCoins.png": 1605,
	"images/enterCode__rewardDeco.png": 3347,
	"images/footer__paniniLogo.png": 8832,
	"images/header__iconBack.png": 84,
	"images/icon__coins.png": 9729,
	"images/sandbox__cover.jpg": 384,
	"images/sandbox__pack.jpg": 789,
	"images/sandbox__shopAlbum.png": 9554,
	"images/sandbox__shopCoins1.png": 1399,
	"images/sandbox__shopCoins2.png": 7900,
	"images/sandbox__shopCoins3.png": 6924,
	"images/sandbox__shopStickers.png": 7266,
	"images/sandbox__shopYearbook.png": 4294,
	"images/sandbox__sticker.jpg": 2835,
	"images/teaser--asobal23-24--de.jpg": 8441,
	"images/teaser--asobal23-24--en.jpg": 1499,
	"images/teaser--asobal23-24--es.jpg": 5711,
	"images/teaser--asobal23-24--fr.jpg": 4714,
	"images/teaser--asobal23-24--it.jpg": 7513,
	"images/teaser--asobal23-24--nl.jpg": 3603,
	"images/teaser--asobal23-24--pt-br.jpg": 9510,
	"images/teaser--brasileirao2024--de.jpg": 1879,
	"images/teaser--brasileirao2024--en.jpg": 6121,
	"images/teaser--brasileirao2024--es.jpg": 7553,
	"images/teaser--brasileirao2024--fr.jpg": 2906,
	"images/teaser--brasileirao2024--it.jpg": 9437,
	"images/teaser--brasileirao2024--nl.jpg": 3807,
	"images/teaser--brasileirao2024--pt-br.jpg": 3951,
	"images/teaser--brasileirao2025--de.jpg": 8626,
	"images/teaser--brasileirao2025--en.jpg": 913,
	"images/teaser--brasileirao2025--es.jpg": 277,
	"images/teaser--brasileirao2025--fr.jpg": 4445,
	"images/teaser--brasileirao2025--it.jpg": 8668,
	"images/teaser--brasileirao2025--nl.jpg": 3589,
	"images/teaser--brasileirao2025--pt-br.jpg": 7999,
	"images/teaser--calciatori-femminile23-24--de.jpg": 889,
	"images/teaser--calciatori-femminile23-24--en.jpg": 5901,
	"images/teaser--calciatori-femminile23-24--es.jpg": 9709,
	"images/teaser--calciatori-femminile23-24--fr.jpg": 7898,
	"images/teaser--calciatori-femminile23-24--it.jpg": 2852,
	"images/teaser--calciatori-femminile23-24--nl.jpg": 5373,
	"images/teaser--calciatori-femminile23-24--pt-br.jpg": 5956,
	"images/teaser--calciatori23-24--de.jpg": 6965,
	"images/teaser--calciatori23-24--en.jpg": 6565,
	"images/teaser--calciatori23-24--es.jpg": 1134,
	"images/teaser--calciatori23-24--fr.jpg": 4733,
	"images/teaser--calciatori23-24--it.jpg": 4527,
	"images/teaser--calciatori23-24--nl.jpg": 6133,
	"images/teaser--calciatori23-24--pt-br.jpg": 7721,
	"images/teaser--de.jpg": 4591,
	"images/teaser--en.jpg": 6265,
	"images/teaser--es.jpg": 2811,
	"images/teaser--fcbq23-24--de.jpg": 8744,
	"images/teaser--fcbq23-24--en.jpg": 3708,
	"images/teaser--fcbq23-24--es.jpg": 6056,
	"images/teaser--fcbq23-24--fr.jpg": 8471,
	"images/teaser--fcbq23-24--it.jpg": 9049,
	"images/teaser--fcbq23-24--nl.jpg": 3466,
	"images/teaser--fcbq23-24--pt-br.jpg": 2014,
	"images/teaser--fcbq24-25--de.jpg": 7118,
	"images/teaser--fcbq24-25--en.jpg": 1166,
	"images/teaser--fcbq24-25--es.jpg": 5552,
	"images/teaser--fcbq24-25--fr.jpg": 1401,
	"images/teaser--fcbq24-25--it.jpg": 2842,
	"images/teaser--fcbq24-25--nl.jpg": 3364,
	"images/teaser--fcbq24-25--pt-br.jpg": 5826,
	"images/teaser--fifa365--de.jpg": 370,
	"images/teaser--fifa365--en.jpg": 2744,
	"images/teaser--fifa365--es.jpg": 2461,
	"images/teaser--fifa365--fr.jpg": 1609,
	"images/teaser--fifa365--it.jpg": 6118,
	"images/teaser--fifa365--nl.jpg": 4028,
	"images/teaser--fifa365--pt-br.jpg": 6482,
	"images/teaser--fifa365_2025--de.jpg": 5710,
	"images/teaser--fifa365_2025--en.jpg": 3957,
	"images/teaser--fifa365_2025--es.jpg": 4140,
	"images/teaser--fifa365_2025--fr.jpg": 2237,
	"images/teaser--fifa365_2025--it.jpg": 1777,
	"images/teaser--fifa365_2025--nl.jpg": 9335,
	"images/teaser--fifa365_2025--pt-br.jpg": 847,
	"images/teaser--fifae2025--de.jpg": 7595,
	"images/teaser--fifae2025--en.jpg": 4757,
	"images/teaser--fifae2025--es.jpg": 9021,
	"images/teaser--fifae2025--fr.jpg": 3636,
	"images/teaser--fifae2025--it.jpg": 9396,
	"images/teaser--fifae2025--nl.jpg": 2025,
	"images/teaser--fifae2025--pt-br.jpg": 8243,
	"images/teaser--foot2023--de.jpg": 5174,
	"images/teaser--foot2023--en.jpg": 5843,
	"images/teaser--foot2023--es.jpg": 6701,
	"images/teaser--foot2023--fr.jpg": 3985,
	"images/teaser--foot2023--it.jpg": 9907,
	"images/teaser--foot2023--nl.jpg": 957,
	"images/teaser--foot2023--pt-br.jpg": 20,
	"images/teaser--foot2024--de.jpg": 3657,
	"images/teaser--foot2024--en.jpg": 9535,
	"images/teaser--foot2024--es.jpg": 5488,
	"images/teaser--foot2024--fr.jpg": 915,
	"images/teaser--foot2024--it.jpg": 9301,
	"images/teaser--foot2024--nl.jpg": 961,
	"images/teaser--foot2024--pt-br.jpg": 5156,
	"images/teaser--fr.jpg": 4595,
	"images/teaser--it.jpg": 8779,
	"images/teaser--laliga--de.jpg": 7942,
	"images/teaser--laliga--en.jpg": 4955,
	"images/teaser--laliga--es.jpg": 2555,
	"images/teaser--laliga--fr.jpg": 4205,
	"images/teaser--laliga--it.jpg": 9824,
	"images/teaser--laliga--nl.jpg": 9231,
	"images/teaser--laliga--pt-br.jpg": 2265,
	"images/teaser--laliga2024-25--de.jpg": 2663,
	"images/teaser--laliga2024-25--en.jpg": 3703,
	"images/teaser--laliga2024-25--es.jpg": 3102,
	"images/teaser--laliga2024-25--fr.jpg": 3292,
	"images/teaser--laliga2024-25--it.jpg": 307,
	"images/teaser--laliga2024-25--nl.jpg": 8970,
	"images/teaser--laliga2024-25--pt-br.jpg": 8451,
	"images/teaser--laliga2025-26--de.jpg": 45,
	"images/teaser--laliga2025-26--en.jpg": 7457,
	"images/teaser--laliga2025-26--es.jpg": 2861,
	"images/teaser--laliga2025-26--fr.jpg": 4382,
	"images/teaser--laliga2025-26--it.jpg": 1722,
	"images/teaser--laliga2025-26--nl.jpg": 3815,
	"images/teaser--laliga2025-26--pt-br.jpg": 8830,
	"images/teaser--laliga2026-27--de.jpg": 7300,
	"images/teaser--laliga2026-27--en.jpg": 8807,
	"images/teaser--laliga2026-27--es.jpg": 8431,
	"images/teaser--laliga2026-27--fr.jpg": 2364,
	"images/teaser--laliga2026-27--it.jpg": 10,
	"images/teaser--laliga2026-27--nl.jpg": 2177,
	"images/teaser--laliga2026-27--pt-br.jpg": 5142,
	"images/teaser--nl.jpg": 1226,
	"images/teaser--ssl2023--de.jpg": 6907,
	"images/teaser--ssl2023--en.jpg": 6961,
	"images/teaser--ssl2023--es.jpg": 6441,
	"images/teaser--ssl2023--fr.jpg": 9705,
	"images/teaser--ssl2023--it.jpg": 7559,
	"images/teaser--ssl2023--nl.jpg": 7785,
	"images/teaser--ssl2023--pt-br.jpg": 8014,
	"images/teaser--teamchile2023--de.jpg": 2185,
	"images/teaser--teamchile2023--en.jpg": 3093,
	"images/teaser--teamchile2023--es.jpg": 9523,
	"images/teaser--teamchile2023--fr.jpg": 4630,
	"images/teaser--teamchile2023--it.jpg": 764,
	"images/teaser--teamchile2023--nl.jpg": 1760,
	"images/teaser--teamchile2023--pt-br.jpg": 9591,
	"images/teaser--voleibol2024--de.jpg": 3227,
	"images/teaser--voleibol2024--en.jpg": 3086,
	"images/teaser--voleibol2024--es.jpg": 4898,
	"images/teaser--voleibol2024--fr.jpg": 5572,
	"images/teaser--voleibol2024--it.jpg": 8274,
	"images/teaser--voleibol2024--nl.jpg": 9634,
	"images/teaser--voleibol2024--pt-br.jpg": 644,
	"images/teaser.jpg": 6588,
	"images/wordmark--long.png": 7939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8422;